<template>
    <div class="login">
        <div class="pc">
            <div class="loginTop">
                <div class="loginLogo warp">
                    <div class="leftBox">
                        <div class="loginImgBox">
                            <img src="@/assets/images/logo.webp" alt="" />
                        </div>
                    </div>
                    <!-- <div class="rightBox" v-if="userName !== ''">
            欢迎您{{userName == 'undefined' ? '' : userName}}
          </div>
          <div v-else class="rightBox">
            我已有云蚨纪<span>快捷登录</span>
          </div> -->
                </div>
            </div>
            <div class="loginCent">
                <div class="entrance">
                    <div class="entranceInfo">
                        <img src="../../assets/images/title.webp" alt="" />
                        <p>用心开好店，打造大事业，与云蚨纪共同展望美好未来。</p>
                    </div>
                    <!-- 新增（2026-10-18，第 118 条）：先选要开通的功能，再选主体 -->
                    <div class="funcPick">
                        <div class="funcPickTitle">第一步：选择要开通的功能</div>
                        <div class="funcOpts">
                            <div
                                class="funcOpt"
                                v-for="o in funcOptions"
                                :key="o.code"
                                :class="{ active: selectedFunc === o.code }"
                                @click="pickFunc(o)"
                            >
                                {{ o.label }}
                                <span v-if="o.companyOnly" class="funcTag">仅企业</span>
                            </div>
                        </div>
                        <div class="funcPickTitle second">第二步：选择入驻主体</div>
                        <div class="funcNote">
                            服务商 / 运营商（无营业执照）<b>无需入驻申请</b>：平台后台可直接为你开通线上商城，请联系平台客服。
                        </div>
                    </div>
                    <!-- 申请跳转按钮 -->
                    <div class="entranceBtn">
                        <div class="btnContainer" v-for="item in pcBtnList" :key="item.value" @click="goToApplication((type = item.type))">
                            <img :src="item.img" alt="" />
                            <span>{{ item.label }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 手机端 -->
        <div class="wap">
            <div class="wapTop">商家入驻</div>
            <div class="wapBan"></div>
            <div class="wapCent">
                <div class="wapCentBox">
                    <!-- 新增（2026-10-18，第 118 条）：先选要开通的功能，再选主体 -->
                    <div class="funcPick">
                        <div class="funcPickTitle">第一步：选择要开通的功能</div>
                        <div class="funcOpts">
                            <div
                                class="funcOpt"
                                v-for="o in funcOptions"
                                :key="o.code"
                                :class="{ active: selectedFunc === o.code }"
                                @click="pickFunc(o)"
                            >
                                {{ o.label }}
                                <span v-if="o.companyOnly" class="funcTag">仅企业</span>
                            </div>
                        </div>
                        <div class="funcPickTitle second">第二步：选择入驻主体</div>
                        <div class="funcNote">
                            服务商 / 运营商（无营业执照）<b>无需入驻申请</b>：平台后台可直接为你开通线上商城，请联系平台客服。
                        </div>
                    </div>
                    <div class="wapItemBox" v-for="item in mbBtnList" :key="item.value">
                        <span>
                            <img :src="item.img" />
                            {{ item.label }}
                        </span>
                        <el-button @click="goToApplication((type = item.type))" type="primary">去申请</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Decrypt } from '@/util/secret.js';
import Cookie from 'js-cookie';
export default {
    name: 'login',
    data() {
        return {
            userName: '',
            // pc端列表渲染
            pcBtnList: [
                {
                    value: 0,
                    img: 'static/imgs/pc/pc-personal.svg',
                    label: '个人商户',
                    type: 'personal'
                },
                {
                    value: 1,
                    img: 'static/imgs/pc/pc-IndividualBusiness.svg',
                    label: '个体工商户',
                    type: 'IndividualBusiness'
                },
                {
                    value: 2,
                    img: 'static/imgs/pc/pc-enterprisesApply.svg',
                    label: '企业商户',
                    type: 'enterprisesApply'
                },
                {
                    value: 3,
                    img: 'static/imgs/pc/pc-organization.svg',
                    label: '其他组织',
                    type: 'organization'
                }
            ],
            // 手机端列表渲染
            mbBtnList: [
                {
                    value: 0,
                    img: 'static/imgs/mb/mb-personal.svg',
                    label: '个人商户',
                    type: 'mPersonal'
                },
                {
                    value: 1,
                    img: 'static/imgs/mb/mb-mUinitBusiness.svg',
                    label: '个体工商户',
                    type: 'mUinitBusiness'
                },
                {
                    value: 2,
                    img: 'static/imgs/mb/mb-mEnterprise.svg',
                    label: '企业商户',
                    type: 'mEnterprise'
                },
                {
                    value: 3,
                    img: 'static/imgs/mb/mb-mOtherOrg.svg',
                    label: '其他组织',
                    type: 'mOtherOrg'
                }
            ],
            // 新增（2026-10-18，第 118 条）：7 种开通功能组合（业务已拍板：F3 不必先开 F2；含 F3 仅限企业）
            selectedFunc: '',
            funcOptions: [
                { code: '1', label: '只开首页店铺展示', companyOnly: false },
                { code: '2', label: '只开线上商城', companyOnly: false },
                { code: '1,2', label: '首页店铺展示 + 线上商城', companyOnly: false },
                { code: '3', label: '只开供应链商城', companyOnly: true },
                { code: '1,3', label: '首页店铺展示 + 供应链商城', companyOnly: true },
                { code: '2,3', label: '线上商城 + 供应链商城', companyOnly: true },
                { code: '1,2,3', label: '首页店铺展示 + 线上商城 + 供应链商城', companyOnly: true }
            ],
            queryParams: { uid: '', url: '' }
        };
    },
    computed: {
        // 新增（2026-10-18，第 118 条）：所选组合是否含供应链商城（仅企业可开）
        isCompanyCombo() {
            return (this.selectedFunc || '').split(',').indexOf('3') > -1;
        }
    },
    watch: {
        $route: {
            handler() {
                this.initQueryParams();
            },
            immediate: true
        }
    },
    created() {
        if (this.userName === '') {
            const data = this.getQueryString('token');
            console.log('token query param:', data);
            Cookie.set('token', data);
            /* if (data) {
                // 只对纯 16 进制串尝试解密；否则直接当成明文 token 使用
                const isHex = /^[0-9A-F]+$/i.test(data);
                if (isHex) {
                    try {
                        const user = Decrypt(data);
                        console.log('decrypted token:', user);
                        Cookie.set('token', user);
                    } catch (e) {
                        console.error('解密 token 失败，当作明文使用:', e);
                        Cookie.set('token', data);
                    }
                } else {
                    // 不是 hex，就直接当作明文 token
                    Cookie.set('token', data);
                }
            } */
        }
    },
    methods: {
        initQueryParams() {
            // 兜底：若未初始化则补上，避免 undefined 报错
            if (!this.queryParams) {
                this.$set(this, 'queryParams', { uid: '', url: '' });
            }
            // 1) 先尝试从 Vue Router 取
            const q = this.$route && this.$route.query ? this.$route.query : {};
            let uidRaw = q.uid || '';
            let urlRaw = q.url || '';

            // 2) 兜底：从地址栏解析（优先 hash，再用 href 的 ?...# 之间）
            if (!uidRaw || !urlRaw) {
                const parsed = this.parseQueryFromLocation();
                if (!uidRaw) uidRaw = parsed.uid || '';
                if (!urlRaw) urlRaw = parsed.url || '';
            }

            // 3) 最多两次解码 url，uid 原样或按需解码
            this.queryParams.uid = uidRaw;
            this.queryParams.url = this.decodePossiblyTwice(urlRaw);

            // 调试打印
            console.log('route.fullPath', this.$route && this.$route.fullPath);
            console.log('href', window.location.href);
            console.log('parsed uid/url', this.queryParams.uid, this.queryParams.url);
        },

        parseQueryFromLocation() {
            const href = window.location.href || '';
            const hash = window.location.hash || '';
            let qs = '';

            // 先从 hash 中找 ? 后的查询串
            const qIdxInHash = hash.indexOf('?');
            if (qIdxInHash > -1) {
                qs = hash.slice(qIdxInHash + 1);
            } else {
                // 再从 href 中找 ? 和 # 之间的查询串
                const qIdx = href.indexOf('?');
                if (qIdx > -1) {
                    const after = href.slice(qIdx + 1);
                    qs = after.split('#')[0];
                }
            }

            const res = {};
            if (qs) {
                qs.split('&').forEach((kv) => {
                    if (!kv) return;
                    const [k, v = ''] = kv.split('=');
                    const key = decodeURIComponent(k || '');
                    const val = decodeURIComponent(v || '');
                    if (key) res[key] = val;
                });
            }
            return { uid: res.uid, url: res.url };
        },
        decodePossiblyTwice(s) {
            if (!s) return '';
            try {
                const once = decodeURIComponent(s);
                // 解码后仍有 %xx 痕迹时再尝试一次
                if (/%[0-9A-Fa-f]{2}/.test(once)) {
                    try {
                        return decodeURIComponent(once);
                    } catch (e) {
                        return once;
                    }
                }
                return once;
            } catch (e) {
                return s;
            }
        },
        // 新增（2026-10-18，第 118 条）：选中功能组合
        pickFunc(o) {
            this.selectedFunc = o.code;
            if (o.companyOnly) {
                this.$message.info('该组合含「供应链商城」，仅限企业（公司）主体入驻');
            }
        },
        goToApplication(type) {
            // 新增（2026-10-18，第 118 条）：未选功能 或 含 F3 但选了非企业主体 → 拦截
            if (!this.selectedFunc) {
                this.$message.warning('请先选择要开通的功能');
                return;
            }
            if (this.isCompanyCombo && type !== 'enterprisesApply' && type !== 'mEnterprise') {
                this.$message.warning('所选功能含「供应链商城」，仅限企业（公司）主体入驻');
                return;
            }
            // 新增（2026-10-18，第 118 条）：跳转时把功能组合带到表单页
            const pathMap = {
                IndividualBusiness: '/individualBusiness',
                personal: '/personal',
                enterprisesApply: '/enterprisesApply',
                organization: '/organization',
                mUinitBusiness: '/mUinitBusiness',
                mEnterprise: '/mEnterprise',
                mPersonal: '/mPersonal',
                mOtherOrg: '/mOtherOrg'
            };
            const path = pathMap[type];
            if (path) {
                this.$router.push({ path: path, query: { funcCodes: this.selectedFunc } });
            }
            /* ===== 旧代码保留（2026-10-18 第 118 条重构为 pathMap，原逐项 if 逻辑见下）
            if (type === 'IndividualBusiness') {
                this.$router.push({ path: '/individualBusiness' });
            }
            if (type === 'personal') {
                this.$router.push({ path: '/personal' });
            }
            if (type === 'enterprisesApply') {
                this.$router.push({ path: '/enterprisesApply' });
            }
            if (type === 'organization') {
                this.$router.push({ path: '/organization' });
            }
            if (type === 'mUinitBusiness') {
                this.$router.push({ path: '/mUinitBusiness' });
            }
            if (type === 'mEnterprise') {
                this.$router.push({ path: '/mEnterprise' });
            }
            if (type === 'mPersonal') {
                this.$router.push({ path: '/mPersonal' });
            }
            if (type === 'mOtherOrg') {
                this.$router.push({ path: '/mOtherOrg' });
            }
            ===== 旧代码保留结束 ===== */
        },
        getQueryString(name) {
            const url = window.location.href || '';
            const qIndex = url.indexOf('?');
            if (qIndex === -1) {
                return null;
            }
            const queryPart = url.slice(qIndex + 1).split('#')[0];
            if (!queryPart) {
                return null;
            }

            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const r = queryPart.match(reg);
            if (r != null) return decodeURIComponent(r[2]);
            return null;
        }
    }
};
</script>

<style lang="scss" scoped>
.login {
    height: 100%;
    min-height: 870px;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/background.webp');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .loginTop {
        background-color: #333333;
        position: relative;
        z-index: 999;
        .loginLogo {
            height: 50px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
                width: 180px;
                margin-right: 30px;
            }
            span {
                font-size: 18px;
                color: $fontColor;
            }
            .loginImgBox {
                width: 51px;
                height: 40px;
                align-items: center;
                display: flex;
                margin-right: 20px;
                cursor: pointer;
                img {
                    width: 100%;
                }
            }
            .leftBox {
                display: flex;
                align-items: center;
                font-weight: 400;
            }
            .rightBox {
                font-size: 16px;
                span {
                    color: #c5aa7b;
                    padding-left: 10px;
                    cursor: pointer;
                }
            }
        }
    }
    .loginCent {
        margin-top: 100px;
        font-family: Microsoft YaHei;
        display: flex;
        justify-content: center;
        align-items: center;
        .entrance {
            /* 新增（2026-10-18，第 118 条）：开通功能选择区 */
            .funcPick {
                width: 700px;
                margin: 0 auto 10px;
                .funcPickTitle {
                    color: #ffebc4;
                    font-size: 14px;
                    margin-bottom: 10px;
                    &.second {
                        margin-top: 18px;
                    }
                }
                .funcOpts {
                    display: flex;
                    flex-wrap: wrap;
                }
                .funcOpt {
                    margin: 0 10px 10px 0;
                    padding: 8px 14px;
                    border: 1px solid rgba(255, 235, 196, 0.5);
                    color: #ffebc4;
                    font-size: 13px;
                    cursor: pointer;
                    border-radius: 2px;
                    &.active {
                        background: #c5aa7b;
                        border-color: #c5aa7b;
                        color: #333333;
                    }
                }
                .funcTag {
                    font-size: 11px;
                    color: #333333;
                    background: #ffebc4;
                    padding: 1px 4px;
                    margin-left: 4px;
                }
                .funcNote {
                    margin-top: 14px;
                    color: rgba(255, 235, 196, 0.7);
                    font-size: 12px;
                    line-height: 1.6;
                }
            }
            .entranceInfo {
                img {
                    display: block;
                    width: 480px;
                    margin: auto;
                }
                p {
                    margin: 30px 0;
                    font-size: 16px;
                    text-align: center;
                    color: #ffffff;
                }
            }
        }
        .entranceBtn {
            width: 700px;
            display: flex;
            justify-content: space-around;
            .btnContainer {
                width: 80px;
                cursor: pointer;
                img {
                    display: block;
                    width: 80px;
                    height: 80px;
                }
                span {
                    display: block;
                    margin-top: 18px;
                    text-align: center;
                    color: #ffebc4;
                }
            }
        }
    }
    .wap {
        display: none;
    }
    .pc {
        height: 100%;
        display: flex;
        flex-direction: column;
        min-height: 768px;
    }
}
@media screen and (max-width: 750px) {
    .warp {
        width: 100%;
    }
    .login {
        background: #f8f8f8;
        position: relative;

        .pc {
            display: none;
        }

        .wap {
            display: block;

            .wapTop {
                height: 60px;
                line-height: 60px;
                color: #fff;
                background-color: #333333;
                font-size: 18px;
                text-align: center;
            }
            .wapBan {
                width: 100%;
                background: url('../../assets/images/mb-background.png') no-repeat top center;
                background-size: contain;
                height: 300px;
            }
            .wapCent {
                position: absolute;
                top: 25%;
                width: 100%;
                .wapCentBox {
                    width: 94%;
                    margin: -50px auto 0 auto;
                    padding: 5%;
                    background: #ffffff;
                    /* 新增（2026-10-18，第 118 条）：开通功能选择区 */
                    .funcPick {
                        margin-bottom: 10px;
                        .funcPickTitle {
                            font-size: 14px;
                            color: #333333;
                            margin-bottom: 8px;
                            &.second {
                                margin-top: 14px;
                            }
                        }
                        .funcOpts {
                            display: flex;
                            flex-wrap: wrap;
                        }
                        .funcOpt {
                            margin: 0 8px 8px 0;
                            padding: 6px 10px;
                            border: 1px solid #dddddd;
                            font-size: 12px;
                            color: #333333;
                            &.active {
                                background: #333333;
                                color: #ffebc4;
                                border-color: #333333;
                            }
                        }
                        .funcTag {
                            font-size: 10px;
                            color: #8a6d3b;
                            margin-left: 3px;
                        }
                        .funcNote {
                            margin-top: 10px;
                            font-size: 11px;
                            color: #999999;
                            line-height: 1.6;
                        }
                    }
                    // box-shadow: 0px 1px 32px 2px #F4F4F4;
                    // border-radius: 10px;
                    .wapItemBox {
                        display: flex;
                        height: 90px;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                        border-bottom: 1px solid #f6f4f7;
                        ::v-deep .el-button--primary {
                            width: 80px;
                            color: #ffebc4;
                            background-color: #333333;
                            border-radius: 0;
                        }
                    }
                    .wapItemBox:last-child {
                        border-bottom: none;
                    }
                    span {
                        display: flex;
                        align-items: center;
                        img {
                            width: 35px;
                            height: 35px;
                            margin-right: 12px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue